import { Component, Input, EventEmitter, Output } from '@angular/core';
import { FieldValue } from '../../../../../@core/models/site-material-data.model';


@Component({
    selector: 'app-material-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss']
})

export class MaterialSelectComponent {
    @Input() positionField: number = undefined;
    @Input() field: number = undefined;
    @Input() formInfos: { name: string; options: string[]; requiredAlertMessage: string; };
    @Input() onBuilder: string = '';
    @Output() setValueEvent = new EventEmitter<FieldValue>();
    value: string = '';
    errorMessage: string = '';
    constructor() { }

    selectValidator($event) {
        if ($event === undefined) {
            this.errorMessage = this.formInfos.requiredAlertMessage ? this.formInfos.requiredAlertMessage : this.formInfos.name + ' is required';
            this.setValueEvent.emit({ type: 'select', value: '', required: false, position: this.field });
        } else {
            this.errorMessage = '';
            this.setValueEvent.emit({ type: 'select', value: $event, required: false, position: this.field });
        }
    }
    touch($event) {
    }
}
